'use client';

import { Fragment } from 'react';
import { Container } from '@/components/common/container';
import { PageNavbar } from '@/app/(protected)/account/page-navbar';
import { AccountUsageContent } from '@/app/(protected)/account/usage/content';

export default function AccountUsagePage() {
  return (
    <Fragment>
      <PageNavbar />
      <Container>
        <AccountUsageContent />
      </Container>
    </Fragment>
  );
}
